<script>
	import InputWrapper from '$lib/Components/Input/InputWrapper.svelte';
	import parsePhone from 'libphonenumber-js';
	import { TelInput, normalizedCountries } from 'svelte-tel-input';

	let {
		error = null,
		disabled = false,
		detailedValue = $bindable(),
		required = false,
		name = 'phone',
		label = null,
		class: className = '',
		country = $bindable(),
		value = $bindable(),
		valid = $bindable(),
		options = {
			spaces: true,
			autoplaceholder: true,
			format: 'national',
		},
		phoneCountry = null,
		phoneNational = null,
	} = $props();

	let number = value ? parsePhone(value) : null;
	if (value) {
		phoneCountry = number?.country;
		phoneNational = number
			?.formatNational()
			?.replace(/[()]/g, '')
			?.replace(/[-]/g, ' ')
			?.trim();
	}

	country = country ?? phoneCountry ?? null;
	value = phoneNational ?? value ?? undefined;
</script>

<InputWrapper {label} {error} class={className}>
	<div class={['flex rounded-lg ']}>
		<select
			class={[
				'form-select border-indow-grey-light text-indow-grey-dark focus:border-indow-grey m-0 block max-w-32 cursor-pointer appearance-none rounded-l-lg border bg-clip-padding bg-no-repeat text-base font-normal focus:ring-0',
				{ 'max-w-40': country === null },
			]}
			autocomplete="tel-country-code"
			name="countryCode"
			bind:value={country}
		>
			<option value={null} hidden={country !== null}>Please select</option>
			<option
				value="US"
				selected={'US' === country}
				aria-selected={'US' === country}
			>
				US (+1)
			</option>
			<option
				value="CA"
				selected={'CA' === country}
				aria-selected={'CA' === country}
			>
				CA (+1)
			</option>
			{#each normalizedCountries as currentCountry (currentCountry.id)}
				<option
					value={currentCountry.iso2}
					selected={currentCountry.iso2 === country}
					aria-selected={currentCountry.iso2 === country}
				>
					{currentCountry.iso2} (+{currentCountry.dialCode})
				</option>
			{/each}
		</select>

		<TelInput
			bind:options
			bind:value
			bind:country
			bind:detailedValue
			bind:required
			bind:disabled
			bind:valid
			{name}
			class={[
				'bg-indow-white text-indow-grey-dark w-full rounded-r-lg px-4 py-1 focus:outline-hidden',
				{
					'border-indow-grey-light border-l-indow-grey-light border': valid,
					'border-indow-red border-2': !valid,
				},
			]}
			autocomplete="tel-national"
		/>
	</div>
</InputWrapper>
